var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8940_5346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4176 0 16 3.58243 16 8C16 12.4176 12.4176 16 8 16C3.58243 16 0 12.4176 0 8C0 3.58243 3.58243 0 8 0ZM9.07969 11.8409V4.15912C9.07969 3.92416 9.27137 3.73247 9.50633 3.73247H10.2762C10.5112 3.73247 10.7029 3.92668 10.7029 4.15912V11.8409C10.7029 12.0733 10.5087 12.2675 10.2762 12.2675H9.50633C9.27389 12.2675 9.07969 12.0758 9.07969 11.8409ZM5.19206 11.8409V4.15912C5.19206 3.92416 5.38375 3.73247 5.61871 3.73247H6.3886C6.62356 3.73247 6.81524 3.92668 6.81524 4.15912V11.8409C6.81524 12.0733 6.62104 12.2675 6.3886 12.2675H5.61871C5.38627 12.2675 5.19206 12.0758 5.19206 11.8409Z",
    fill: "#FF6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8940_5346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldIcon);
export default __webpack_public_path__ + "static/media/hold-icon.6581ebef14781a553bb073c86860fc80.svg";
export { ForwardRef as ReactComponent };